module.exports = __webpack_public_path__ + "static/image9-390fbf01ecc0b973f41caedd6f87d678.jpeg";